// System
import { Box } from '@mui/system';

// Features
import { Divider } from '@mui/material';
import { LocalizationsTitle } from '@Features/localizations/LocalizationsTitle/LocalizationsTitle';
import { LocalizationsList } from '@Features/localizations/LocalizationsList/LocalizationsList';

export const LocalizationsPage = () => {
  return (
    <Box>
      <Box>
        <LocalizationsTitle />
        <Divider />
        <LocalizationsList />
      </Box>
    </Box>
  );
};
